import {useLocale} from '#build/imports';

export function usePriceFormatter(currency: string = 'EUR') {
    const {locale} = useLocale();
    const priceFormatter = new Intl.NumberFormat(locale.value, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return {
        format: priceFormatter.format,
    };
}
